import React from 'react';
import { styled } from '@mui/material/styles';
import { Tooltip, tooltipClasses } from '@mui/material';

// Default Popper positioning modifiers so a tooltip whose content is tall or
// wide repositions itself to stay fully inside the viewport (arrow re-centers
// or shifts toward whichever side has room) instead of overflowing past the
// top/side of the screen. `tether: false` is the key option: MUI/Popper's own
// default (`tether: true`) keeps the popper glued to the anchor's edge even
// when that means the box runs off-screen; `false` lets it detach and settle
// wherever it fits. A caller's own `slotProps.popper` (e.g. a custom z-index)
// is merged on top, not replaced.
const DEFAULT_POPPER_MODIFIERS = [
  {
    name: 'preventOverflow',
    options: {
      boundary: 'viewport',
      padding: 8,
      altAxis: true,
      tether: false,
    },
  },
  {
    name: 'flip',
    options: {
      padding: 8,
      fallbackPlacements: ['bottom', 'top', 'right', 'left'],
    },
  },
];

const CustomTooltip = styled(({ className, maxWidth, slotProps, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    slotProps={{
      ...slotProps,
      popper: {
        modifiers: DEFAULT_POPPER_MODIFIERS,
        ...(slotProps?.popper || {}),
      },
    }}
  />
))(({ theme, maxWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#4C5B62',
    color: '#ffffff',
    maxWidth: maxWidth || '339px',
    fontSize: '14px',
    borderRadius: '6px',
    lineHeight: '20px',
    padding: '8px 12px',
    fontWeight: 400,
    fontFamily: 'Source Sans Pro',
    alignSelf: 'stretch',
    fontStyle: 'normal',
    letterSpacing: '0px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#4C5B62',
    '&:before': {
      backgroundColor: '#4C5B62',
      border: 'none',
    }   
  },
}));

export default CustomTooltip;
